<script setup>
import { defineProps } from "vue";

const props = defineProps({
    iconURL: { type: String, required: false },
    showRings: {
        type: Boolean,
        default: true
    },
    innerColor: {
        type: String,
        default: "#717784"
    }
});
</script>

<template>
    <div class="relative flex flex-col items-center justify-center mt-24">
        <div
            v-if="showRings"
            class="absolute w-118 h-118 border border-[#E4E7EC] rounded-full opacity-25 z-0"
        ></div>
        <div
            v-if="showRings"
            class="absolute w-98 h-98 border border-[#E4E7EC] rounded-full opacity-45 z-0"
        ></div>
        <div
            v-if="showRings"
            class="absolute w-78 h-78 border border-[#E4E7EC] rounded-full opacity-60 z-0"
        ></div>
        <div
            v-if="showRings"
            class="absolute w-58 h-58 border border-[#E4E7EC] rounded-full opacity-70 z-0"
        ></div>
        <div
            v-if="showRings"
            class="absolute w-38 h-38 border border-[#E4E7EC] rounded-full opacity-75 z-0"
        ></div>
        <div
            class="absolute w-22 h-22 border border-[#E4E7EC] rounded-full opacity-20 z-0"
            :style="{ 
                background: `radial-gradient(at 25% 25%, white, ${props.innerColor})` 
            }"
        ></div>
        <div
        class="relative flex flex-col items-center justify-center p-4 rounded-full bg-white z-0"
        >
            <slot>
                <img v-if="iconURL" :src="iconURL" alt="Referral Icon" class="w-20 md:w-24" />
            </slot>
        </div>
    </div>
</template>
